import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { mdiClose } from "@mdi/js";
import { Svg } from "../components/Svg";

const DialogWrapperStyle = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .4);
`;

const DialogStyle = styled.div.attrs(props =>
    ({ style: { transform: `translate(${props.$position.x}px, ${props.$position.y}px)`, }, }))`
    position: relative;
    width: ${props => props.width};
    box-shadow: ${props => props.theme.boxShadow};
    border: 1px solid ${props => props.theme.greyLight};
    background-color: ${props => props.theme.greyLightest};
`;

const DialogHeaderStyle = styled.div`
    display: flex;
    height: 35px;
    font-size: 15px;
    align-items: center;
    padding: 0 25px 0 30px;
    justify-content: space-between;
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.primaryLight};
    svg {
        &:hover,
        &:focus {
            text-decoration: none;
            color: ${props => props.theme.primaryLighter};
        }
    }
`;

export const Dialog = props => {
    const { width, title, children } = props;
    const [dragState, setDragState] = useState({
        isDragging: false,
        x: 0,
        y: 0,
        startX: 0,
        startY: 0
    });

    const onMouseDown = event => {
        event.stopPropagation();
        setDragState({
            ...dragState,
            isDragging: true,
            startX: event.clientX - dragState.x,
            startY: event.clientY - dragState.y
        });
    };

    useEffect(() => {
        const onMouseMove = event => {
            if (dragState.isDragging) {
                setDragState({
                    ...dragState,
                    x: event.clientX - dragState.startX,
                    y: event.clientY - dragState.startY
                });
            }
        };

        const onMouseUp = () => {
            setDragState({ ...dragState, isDragging: false });
        };

        if (dragState.isDragging) {
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
        }
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [dragState]);

    useEffect(() => {
        const handleKeyDown = ({ keyCode }) => keyCode === 27 && props.onClose();
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [props.onClose]);

    return ReactDOM.createPortal(
        <DialogWrapperStyle>
            <DialogStyle
                width={width}
                onClick={event => event.stopPropagation()}
                $position={{ x: dragState.x, y: dragState.y }}>
                {title && (
                    <DialogHeaderStyle onMouseDown={onMouseDown}>
                        <span>{title}</span>
                        <Svg path={mdiClose} size="16" onClick={props.onClose} />
                    </DialogHeaderStyle>
                )}
                {children}
            </DialogStyle>
        </DialogWrapperStyle>,
        document.getElementById("dialog")
    );
};